<template>
    <div class="container-fluid py-5 wow fadeInUp img" data-wow-delay="0.1s" :style="{ backgroundImage: 'url('+$app_image+'error-404-page-found-nat404-notFound.avif) '}">
    <div style="margin-top: 130px;" class="container text-center">
      <div class="row justify-content-center mt-12">
        <div class="col-lg-6">
          <i class="bi bi-exclamation-triangle display-1 text-primary"></i>
          <h1 class="display-1 fw-bolder">404</h1>
          <h1 class="mb-4 fw-bolder">Không tìm thấy trang</h1>
            <router-link class="text-dark py-3 px-5 link" to="/"><button class="learn-more text-secondary fs-6">Quay Lại</button></router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    const meta = document.createElement('meta')
    meta.name = "robots"
    meta.content = "noindex, nofollow"
    document.head.appendChild(meta)
  },
  beforeUnmount() {
    const existing = document.querySelector('meta[name="robots"]')
    if (existing) document.head.removeChild(existing)
  }
}
</script>
<style src="./404.css" scoped></style>
